export default __webpack_public_path__ + "static/media/aprj.e2de3eed.png";